import { LayoutServiceData, RouteData } from "@sitecore-jss/sitecore-jss-react";

// We supply this url prop in the context via both ssr (see server.tsx:parseServerData
// and via client side by using window here.
export function prepContext(routeData: LayoutServiceData) {
  // Use the URL from the server if available, otherwise fall back to the client URL.
  const url =
    (routeData?.sitecore?.route?.fields && routeData.sitecore.route.fields.url) ||
    (typeof window !== 'undefined' ? window.location.href : '');
    
  // Merge the existing fields with the new url property.
  const updatedFields = {
    ...routeData.sitecore.route!.fields,
    url,
  };

  // Create a new route object with the updated fields.
  const updatedRoute = {
    ...routeData.sitecore.route,
    fields: updatedFields,
  };

  return {
    route: updatedRoute as RouteData,
    itemId: routeData?.sitecore?.route?.itemId,
    ...routeData.sitecore.context,
  };
}

